module.exports = __webpack_public_path__ + "60c866748ff15f5b347fdba64596b1b1.woff2";